export default __webpack_public_path__ + "static/media/question-mark.7cdc1fe0.svg";